// The planner: bottom tab bar like the game's main menu, panels per system.
import { useState } from "react";
import { useAuth } from "../auth/AuthProvider";
import { UserBadge } from "../components/UserBadge";
import { LoginButton } from "../components/LoginButton";
import { CardsPanel } from "../components/planner/CardsPanel";
import { ImportPanel } from "../components/planner/ImportPanel";
import { LabsPanel } from "../components/planner/LabsPanel";
import { RelicsPanel } from "../components/planner/RelicsPanel";
import { StepProvider, StepToggle } from "../components/planner/StepContext";
import { UwPanel } from "../components/planner/UwPanel";
import { WorkshopPanel } from "../components/planner/WorkshopPanel";
import { usePlayerState, type SyncStatus } from "../game/usePlayerState";

const TABS = ["Workshop", "UWs", "Cards", "Labs", "Relics", "Import"] as const;
type Tab = (typeof TABS)[number];

const STATUS_LABEL: Record<SyncStatus, string> = {
  local: "saved locally — sign in to sync",
  loading: "loading…",
  synced: "synced",
  saving: "saving…",
  error: "sync error — changes kept locally",
};

export function Planner() {
  const { user } = useAuth();
  const { state, update, status } = usePlayerState();
  const [tab, setTab] = useState<Tab>("Workshop");

  return (
    <StepProvider>
      <div className="planner">
        <header className="planner-header">
          <h1>The Tower — Planner</h1>
          <span className={`sync-status status-${status}`}>{STATUS_LABEL[status]}</span>
          <StepToggle />
          {user ? <UserBadge /> : <LoginButton />}
        </header>

      <main className="planner-body">
        {tab === "Workshop" && <WorkshopPanel state={state} update={update} />}
        {tab === "UWs" && <UwPanel state={state} update={update} />}
        {tab === "Cards" && <CardsPanel state={state} update={update} />}
        {tab === "Labs" && <LabsPanel state={state} update={update} />}
        {tab === "Relics" && <RelicsPanel state={state} update={update} />}
        {tab === "Import" && <ImportPanel state={state} update={update} />}
      </main>

      <nav className="tab-bar">
        {TABS.map((t) => (
          <button key={t} className={t === tab ? "active" : ""} onClick={() => setTab(t)}>
            {t}
          </button>
        ))}
      </nav>

      </div>
    </StepProvider>
  );
}
